import React from 'react';
import { FadeInUp, SectionLabel } from './AnimationWrappers';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const SustainabilityPreview = () => {
  return (
    <section id="sustainability-preview" data-testid="sustainability-preview-section" className="relative overflow-hidden" style={{ background: '#F0F7F2', padding: '60px 0' }}>
      <div className="container-main">
        <SectionLabel number="09" title="Sustainability" />
        <FadeInUp>
          <div className="accent-line" style={{ background: '#2D8B4E' }} />
          <h2 className="font-display mb-4" style={{ fontSize: 'clamp(1.8rem, 4vw, 2.4rem)', fontWeight: 700, color: '#1C1C1E' }}>
            Green Manufacturing. <span style={{ color: '#2D8B4E' }}>By Design.</span>
          </h2>
          <p className="font-body mb-8" style={{ fontSize: '0.95rem', color: '#3A3A3C', maxWidth: '600px', lineHeight: 1.7 }}>
            Solar energy, rainwater harvesting, water treatment, and waste segregation — built into the factory from the ground up.
          </p>
        </FadeInUp>

        <FadeInUp delay={0.1}>
          <div className="grid grid-cols-3 gap-3 md:gap-4 mb-8">
            {[
              { value: '60%', label: 'Solar Energy' },
              { value: '95%', label: 'Material Utilization' },
              { value: '40%', label: 'Carbon Reduction' },
            ].map((s, i) => (
              <div key={i} className="text-center" style={{ background: '#FFFFFF', borderRadius: '12px', padding: 'clamp(0.8rem, 2vw, 1.2rem) 0.8rem', border: '1px solid rgba(45,139,78,0.15)' }}>
                <span className="font-display block mb-1" style={{ fontSize: 'clamp(1.2rem, 3vw, 1.8rem)', fontWeight: 700, color: '#2D8B4E' }}>{s.value}</span>
                <span className="font-mono" style={{ fontSize: '0.55rem', color: '#6B6B6F', textTransform: 'uppercase', letterSpacing: '0.1em' }}>{s.label}</span>
              </div>
            ))}
          </div>
        </FadeInUp>

        <FadeInUp delay={0.2}>
          <Link
            to="/sustainability"
            data-testid="sustainability-view-more"
            className="inline-flex items-center gap-2 font-mono text-[0.75rem] tracking-[0.08em] uppercase px-6 py-3 rounded transition-all duration-300 hover:gap-4"
            style={{ background: '#2D8B4E', color: '#FFFFFF' }}
          >
            Our Green Initiatives <ArrowRight size={14} />
          </Link>
        </FadeInUp>
      </div>
    </section>
  );
};

export default SustainabilityPreview;
